import React from "react";
import Moment from "react-moment";
import "./MobileExpenseAnswerSummary.scss";

/**
 * Resumen del gasto dentro del modal de aprobar/denegar.
 */
const MobileExpenseAnswerSummary = ({ expense, expenseTypes }) => {
	const employee = expense.requester;
	const fullName = employee
		? `${employee.name ?? ""} ${employee.surname ?? ""}`.trim()
		: "";
	const typeObj =
		expense.type ??
		expenseTypes?.find((t) => t.id === expense.type_id);
	const categoryLabel = typeObj?.name ?? expense.type_name ?? "";

	return (
		<div className="expense-answer-summary">
			<div className="expense-answer-summary__row">
				<div className="expense-answer-summary__avatar">
					{employee?.name ? employee.name.charAt(0).toUpperCase() : "?"}
					{employee?.surname
						? employee.surname.charAt(0).toUpperCase()
						: ""}
				</div>
				<div className="expense-answer-summary__user-date">
					<span className="expense-answer-summary__name">
						{fullName || "—"}
					</span>
					<span className="expense-answer-summary__dot">·</span>
					<Moment
						format="DD/MM/YYYY"
						className="expense-answer-summary__date"
					>
						{expense.day}
					</Moment>
					<span className="expense-answer-summary__dot expense-answer-summary__dot--desktop">
						·
					</span>
					<span className="expense-answer-summary__amount expense-answer-summary__amount--desktop">
						{expense.value} €
					</span>
				</div>
			</div>
			<div className="expense-answer-summary__row expense-answer-summary__row--meta">
				<div className="expense-answer-summary__price-type">
					<span className="expense-answer-summary__amount expense-answer-summary__amount--mobile">
						{expense.value} €
					</span>
					{categoryLabel ? (
						<span
							className="expense-type-tag expense-answer-summary__tag"
							style={{
								backgroundColor: typeObj?.background_color || undefined,
								border: typeObj?.border_color
									? `2px solid ${typeObj.border_color}`
									: undefined,
							}}
						>
							{categoryLabel}
						</span>
					) : null}
				</div>
			</div>
		</div>
	);
};

export default MobileExpenseAnswerSummary;
